export default __webpack_public_path__ + "media/images/lock-e7c0d51dea02a270c9ae128beafdd540.png";